const ToConnectionRequestTypeEnum = {
  HOTEL: 'hotel',
  EXPERIENCE: 'experience',
  TEMPLATE: 'template',
};

export default ToConnectionRequestTypeEnum;
